import { datadogRum } from '@datadog/browser-rum';
import { sanitizeErrorForTracking } from '@knack/tooling-dev-scrubbers';

import { shouldEnableDatadogRum } from '@/lib/env-helper';

type DatadogRumAction = 'NavigateToBuilderNext' | 'NavigateToDashboard' | string;

export const safeDatadogRumAddAction = (
  name: DatadogRumAction,
  context: Record<string, unknown> = {},
  app = null,
) => {
  if (shouldEnableDatadogRum(app)) {
    datadogRum.addAction(name, context);
  }
};

export const safeDatadogRumAddError = (
  error: Error | string,
  context: Record<string, unknown> = {},
  app = null,
) => {
  if (shouldEnableDatadogRum(app)) {
    // Convert string errors to Error objects for sanitization
    const errorObject = typeof error === 'string' ? new Error(error) : error;
    const sanitizedError = sanitizeErrorForTracking(errorObject);
    datadogRum.addError(sanitizedError, context);
  }
};

export const safeDatadogRumSetUser = (user: {
  id: string;
  name?: string;
  email?: string;
  [key: string]: unknown;
}, app = null) => {
  if (shouldEnableDatadogRum(app)) {
    datadogRum.setUser(user);
  }
};

export const safeDatadogRumClearUser = (app = null) => {
  if (shouldEnableDatadogRum(app)) {
    datadogRum.clearUser();
  }
};
